__turbopack_context__.v({
  "btn": "ButtonsHideAmount-module-scss-module__DIu0ua__btn",
  "btn__advantages": "ButtonsHideAmount-module-scss-module__DIu0ua__btn__advantages",
  "btn__advantages__wrapp": "ButtonsHideAmount-module-scss-module__DIu0ua__btn__advantages__wrapp",
  "btn__hideAdv": "ButtonsHideAmount-module-scss-module__DIu0ua__btn__hideAdv",
  "btn__special": "ButtonsHideAmount-module-scss-module__DIu0ua__btn__special",
  "btn__special__unvisible": "ButtonsHideAmount-module-scss-module__DIu0ua__btn__special__unvisible",
  "btn__wrapp": "ButtonsHideAmount-module-scss-module__DIu0ua__btn__wrapp",
  "btn__wrapp__info": "ButtonsHideAmount-module-scss-module__DIu0ua__btn__wrapp__info",
  "show": "ButtonsHideAmount-module-scss-module__DIu0ua__show",
});
